
import Parse from 'parse';
import React from 'react';

const ingredTypeCount = 8;

class Recipe extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            recipes: {},
            curRecipe: null,
            ingredTypes: ["🥦 VEGGIES", "🍓 FRUITS", "🌱 BEANS", "🍚 GRAINS", "🥜 SEEDS & NUTS", "🌶 SPICES", "🥫 PRODUCTS", "✔️ INSTRUCTIONS"],
            ingredFields: ["veggiesData", "fruitsData", "beansData", "grainsData", "seedsData", "spicesData", "productsData", "instructionsData"],
            ingredImages: ["veggies.png", "fruits.png", "beans.png", "grains.png", "seeds.png", "spices.png", "products.png", "instructions.png"],
            curRecipeName: "Default",
            ingredArr: [],
        };

        // Creates all lines:
        for(var i=0; i < ingredTypeCount; i++) {

          // Creates an empty line
          this.state.ingredArr.push([]);
          //this.state.ingredArr[i].push( []);

          // Adds cols to the empty line:
         //   this.state.ingredArr[i].push( new Array());
/*
          for(var j=0; j < cols; j++){
            // Initializes:
            arr[i][j] = defaultValue;
          }*/
        }

        //this.state.curRecipe = this.props.recipe;
        console.log("this.props.recipe " + this.props.recipe);

        //do this to load the items
        this.selectRecipe(this.props.recipe);

        this.getRecipes = this.getRecipes.bind(this);
        this.getCurRecipe = this.getCurRecipe.bind(this);
    }


    selectRecipe(recipe) {
      //this.setState({curRecipe:recipe});
        if (recipe)
          console.log('Select recipe ' + recipe.get("name"));

         if (this.state.curRecipe != recipe) 
        {
            this.state.curRecipe = recipe;
            this.state.curRecipeName = recipe.get("name");
            
            console.log("CurRecipe " + JSON.stringify(recipe));

            //load the itemArr
            var newIngredArr = [];

            for (var i = 0; i < ingredTypeCount; i++)
            {
                var curIngredType = this.state.ingredTypes[i].toLowerCase();

                var fieldName = this.state.ingredFields[i]; ///curIngredType + "Data";
                var serData = recipe.get(fieldName);
                if (serData)
                {
                    console.log("Parsing serial data " + fieldName + " " + serData);
                    var serObj = JSON.parse(serData);
                    newIngredArr.push(serObj);
                }
                else
                    newIngredArr.push([]);
            }
            this.state.ingredArr = newIngredArr;
        }
        //this.state.curRecipe = recipe;
    }

    getCurRecipe() {
        return this.curRecipe;
    }

    getRecipes(event) {
        event.preventDefault();
        this.getRecipesAux();
    }

    renderIngredientType(ingredType, i) {
        let buffer = [];

        //console.log("renderIngredientType " + i + " ingredArr len " + this.state.ingredArr[i].length)
        for (var k = 0; k < this.state.ingredArr[i].length; k++)
        {
            var ingred = this.state.ingredArr[i][k];

           // console.log("ingredArr " + i + " " + ingred.name);

            /* ======================== INGREDIENT COMPONENTS =========================== */

            if (i != 7) 
            {
            buffer.push( <div className="recipeIngred">
                          <span>{this.state.ingredArr[i][k].amount}</span>&nbsp;

                           <span><a href="/appstore/">{this.state.ingredArr[i][k].name}</a>&nbsp;</span>&nbsp;

                           <span>{this.state.ingredArr[i][k].description}</span>
                    </div>);
            }
            else
            {
                //instructions
                var stepText = "Step ";

                //**/
                buffer.push( <div className="recipeIngred" key={500+((i+1)*(k+1))}>
                           <span>{k+1}.&nbsp;&nbsp;</span>

                           <span>{this.state.ingredArr[i][k].description}</span>
                    </div>);
            }
        }
        //console.log("ingredArr length " + this.state.ingredArr[i].length);
        if ((this.state.ingredArr[i].length == 0) && (i != 7))
        {
            buffer.push( 
                            <div className="recipePostamble">None this meal.</div>
                        );
        }
        else //if (i != 7)
        {/* *
            buffer.unshift( <table><tbody>
                            <tr class = "ingredRow" key={499+(i+1)}>
                           <td class = "ingredAmountHeader">

                                Amount

                           </td>
                           <td class = "ingredNameHeader">

                               Name

                           </td>
                           <td class = "ingredDescripHeader">

                               Description

                           </td>
                           <td class = "ingredDeleteHeader">
                            ..

                           </td>
                        </tr>
                    </tbody></table>
                        );*/

        }

        var ingredImage = "images/" + this.state.ingredImages[i];
        
        return (
            <div>
            <b>
            {ingredType}</b><br/>
                    {buffer}
            </div>
            );
    }

    renderIngredients()
    {
        //console.log("renderIngredients");
        //return      <span key="66"><h4> ingredType  <a onClick={() => this.handleAdd(0)} >Add</a></h4></span>;

        let buffer = [];

        for (var i = 0; i < this.state.ingredTypes.length; i++)
        {
            var ingredType = this.state.ingredTypes[i];
            if (ingredType != undefined)
            buffer.push(<div className="recipeSectionHeader" key={69*i}>
                            {this.renderIngredientType(ingredType, i)}
                        </div>);
        }
        

        return ( <div key="11">
                {buffer}
                </div>
        );
        /*
        console.log("map" + ingredType + i);
            return (
               <div>
               <span key={i+100}><h4> {ingredType}  <a onClick={() => this.handleAdd(i)} >Add</a></h4></span>
               </div>
            );

            
        });*/
    }

    renderRecipeV2()
    {
        //console.log("renderIngredients");
        //return      <span key="66"><h4> ingredType  <a onClick={() => this.handleAdd(0)} >Add</a></h4></span>;

        let buffer = [];

        var formatIngred = this.formatComment( this.state.curRecipe.get("ingredients") );
        var formatInstruc = this.formatComment( this.state.curRecipe.get("instructions") );
        var formatNotes = this.formatComment( this.state.curRecipe.get("notes") );

        console.log("Recipe: "+ JSON.stringify(this.state.curRecipe));

        buffer.push(<div><div className="recipeSectionHeader" key={69*1}>
                            <div className="recipeHeaderLabel"><b>
                            Ingredients</b></div>
                             <div className="recipeIngred">
                                 <div dangerouslySetInnerHTML={{ __html: formatIngred}} />
                            </div> 
                           
                        </div>
                    <div className="recipeSectionHeader" key={69*1}>
                            <div className="recipeHeaderLabel"><b>
                            Instructions</b></div>
                             <div className="recipeIngred">
                                 <div dangerouslySetInnerHTML={{ __html: formatInstruc}} />
                            </div> 
                           
                        </div>
                    </div>);
        

        return ( <div key="11">
                {buffer}
                </div>
        );
        /*
        console.log("map" + ingredType + i);
            return (
               <div>
               <span key={i+100}><h4> {ingredType}  <a onClick={() => this.handleAdd(i)} >Add</a></h4></span>
               </div>
            );

            
        });*/
    }

    formatComment(origComment)
    {
        if (!origComment)
          return "";

        var stringSplit = origComment.split(" ");
        var result = "";

        for(var i =0; i < stringSplit.length; i++){
            var comp = stringSplit[i];
            var firstChar = comp.charAt(0);

            if (firstChar == "#")
            {
                result += '<a href="/appstore">' + comp + '</a>';
            }
            else if ((comp.indexOf("http://") !== -1) || (comp.indexOf("https://") !== -1))
            {
                //link
                result += '<a href="' + comp + '"">' + comp + '</a>';
            }
            else
            {
                result += comp;
            }
            result += " ";
        }

        //replace newlines with breaks
        result = result.split("\n").join("<br>");

        return result;
    }

    renderPostamble()
    {
        let buffer = [];
        var result;

        if (!this.state.curRecipe)
        {
            return (<div></div>);
        }
        var formatWS = this.formatComment( this.state.curRecipe.get("website") );
        var formatHash = this.formatComment( this.state.curRecipe.get("hashtags") );

        result =  (
                 <div className="recipePostamble" key="-1">
                        
                        <div dangerouslySetInnerHTML={{ __html: formatWS}} />
                        <br/>
                        <div dangerouslySetInnerHTML={{ __html: formatHash}} />
                </div>
                );

        return result;
    }

    render() {
        //console.log("Rendering recipe list");
        var result = (
            <div>
            </div>

        );
        {
            var self = this;

            if (this.state.curRecipe != null)
            {
                result =  (
                 <div className="recipeDiv" key="-1">
                        <span>&nbsp;{this.state.curRecipe.get("name")}</span>
                        
                        {this.renderRecipeV2()}

                        <br/>
                </div>
              );

            }


        }
        return result;
        /* 
                    <label className="checkbox">
                        <input type="checkbox" value="remember-me" onChange={this.handleRememberMeClick}/>
                        &nbsp; Remember me
                    </label>
                    */

    }


}

export default Recipe;


// WEBPACK FOOTER //
// ./src/recipe.jsx